import { render, staticRenderFns } from "./InventorRelationLink.vue?vue&type=template&id=4094d0d0&scoped=true"
import script from "./InventorRelationLink.vue?vue&type=script&lang=js"
export * from "./InventorRelationLink.vue?vue&type=script&lang=js"
import style0 from "./InventorRelationLink.vue?vue&type=style&index=0&id=4094d0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094d0d0",
  null
  
)

export default component.exports